const thirdParty = {
  thirdParty: {
    pageHeader: 'Registrazione nuovo utente',
    clearState: 'Cancella stato',
    register: 'Registrati',
    systemRegistrationSummary: 'Riepilogo della registrazione nel sistema',
    registrationProgress: '%{Registration_in_progress} in corso',
    registrationComplete: '%{registration_complete} completata',
    thirdPartyLogin:
      'Per gestire il tuo account PowerDash, devi accedere come proprietario del sito',
    thirdPartyInvalidURI:
      "L'URI richiesto non è valido oppure la risorsa richiesta, ad esempio un sistema, non esiste."
  }
};

export default thirdParty;
